export default {
    value: ''
};